/* Shared PDP detection helper for the try-on / AR / recommendations widgets.
 *
 * webshop's PDP (templates/generators/item/item.html) is not owned by
 * websitehq and carries no data-item-code on a universal element - the one
 * webshop puts on .btn-configure only exists for variant/template items
 * (see pdp_variant_swatches.js). item_details.html DOES unconditionally
 * render the item code as plain text inside `.product-code .product-item-code`
 * + sibling span (the schema.org Product "sku"-ish label), which is the one
 * reliable universal anchor for the item's code on every PDP.
 */

export function isPdp() {
	return Boolean(document.querySelector('[data-doctype="Website Item"][source-type="Generator"]'));
}

export function getPdpItemCode() {
	var label = document.querySelector('.product-code .product-item-code');
	if (!label) return null;
	var codeEl = label.nextElementSibling;
	var code = codeEl && codeEl.textContent ? codeEl.textContent.trim() : '';
	return code || null;
}

export function getPdpMainBlock() {
	return document.querySelector('.product-container.item-main');
}
